import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import AlertLogo from '../../assets/imgs/new/paymentSuccess.png';
function CustomAlert() {
	const { isOpen, message } = useSelector(state => state.customAlert);
	return (
		<>
			<Modal isOpen={isOpen} centered>
				<ModalBody className='text-center bg-white'>
					<img src={AlertLogo} alt='Alert Logo' />
					<br />
					<div className='mt-4'>
						<strong>{message}</strong>
					</div>
				</ModalBody>
			</Modal>
		</>
	);
}

export default CustomAlert;
